import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Platform } from '@app/classes';
import { BulkSelectEmployeeDialogComponent } from '@app/components';
import { Columns, Row } from '@app/components/simple-table/simple-table.component';
import { QueryFetcher } from '@app/models/core/query-fetcher.model';
import { Employee } from '@app/models/employee/employee.model';

@Component({
    selector: 'app-assign-time-tracking-employees-to-payroll-integration-table',
    templateUrl: './assign-time-tracking-employees-to-payroll-integration-table.template.html',
    styleUrls: ['./assign-time-tracking-employees-to-payroll-integration-table.style.scss'],
})
export class AssignTimeTrackingEmployeesToPayrollIntegrationTable {
    @ViewChild('selectEmployees', { static: true }) selectEmployees!: BulkSelectEmployeeDialogComponent;
    @Input() employees: Employee[] = [];
    @Output() onEmployeesChange: EventEmitter<Employee[]> = new EventEmitter<Employee[]>();

    rows: Row[] = [];
    isLoading = false;

    columns: Columns[] = [
        { columnName: 'time-tracking.payrollIntegrationPage.table.name', columnSpan: 'columns-4' },
        { columnName: 'time-tracking.payrollIntegrationPage.table.position', columnSpan: 'columns-3' },
        { columnName: 'time-tracking.payrollIntegrationPage.table.department', columnSpan: 'columns-3' },
    ];

    private searchQuery = '';

    ngOnChanges(): void {
        this.populateTable();
    }

    onSearch(searchQuery: string | null): void {
        this.searchQuery = searchQuery ?? '';
        this.populateTable();
    }

    async openEmployeeSelect(): Promise<void> {
        const employeesWhoWillBeOnIntegration = await this.selectEmployees.show<Employee[]>(this.employees);

        if (employeesWhoWillBeOnIntegration === null) {
            return;
        }

        this.onEmployeesChange.emit(employeesWhoWillBeOnIntegration);
    }

    async removeEmployeeByIndex(indexToRemove: number): Promise<void> {
        const employees = this.employees.filter((_, idx) => idx !== indexToRemove);
        this.onEmployeesChange.emit(employees);
    }

    whereOnTimeTrackingAndPayroll(query: QueryFetcher): QueryFetcher {
        return query.where('isAssignedModule', Platform.modules.timeTracking).where('onPayroll', 1);
    }

    private populateTable(): void {
        const employees = this.employees.filter((employee: Employee) => {
            if (!this.searchQuery) {
                return true;
            }
            return employee.fullName.toLowerCase().includes(this.searchQuery.toLocaleLowerCase());
        });

        this.rows = employees.map((employee: Employee): Row => {
            return {
                cells: [
                    { employee, isAvatar: true },
                    employee.position?.title ?? '-',
                    employee.department?.name ?? '-',
                ],
            };
        });
    }
}
